var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrazil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_4819)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_4819",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_4819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V23H35.2819V3Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2829 12.9966L18.1409 20.5695L29.999 12.9966L18.1409 5.42383L6.2829 12.9966Z",
    fill: "#EDC223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 12.9966C23.1426 15.7553 20.8996 17.9983 18.141 17.9983C15.3823 17.9983 13.1393 15.762 13.1393 12.9966C13.1393 10.238 15.3756 7.99496 18.141 7.99496C20.8996 7.99496 23.1426 10.238 23.1426 12.9966Z",
    fill: "#31276C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2819 10.854C14.6994 10.854 14.1235 10.8942 13.5678 10.9746C13.4607 11.2223 13.3736 11.4767 13.3 11.7379C13.9427 11.624 14.6056 11.5638 15.2819 11.5638C18.2146 11.5638 20.8862 12.6686 22.9083 14.4831C22.9886 14.2287 23.0489 13.9608 23.089 13.693C20.9799 11.9253 18.2548 10.854 15.2819 10.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8758 11.537C13.9963 11.5236 14.0767 11.4031 14.0566 11.2759C14.0432 11.1487 13.9294 11.0482 13.8155 11.0683C13.695 11.0817 13.6147 11.2022 13.6348 11.3294C13.6548 11.4567 13.762 11.5504 13.8758 11.537ZM13.8691 11.45C13.9361 11.4433 13.9829 11.3696 13.9762 11.2893C13.9628 11.2089 13.9026 11.1487 13.8356 11.1553C13.7687 11.162 13.7218 11.2357 13.7285 11.316C13.7352 11.3964 13.7955 11.4567 13.8691 11.45Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2641 11.4901L14.3512 11.4834L14.3378 11.3093L14.5253 11.2959C14.6056 11.2892 14.6726 11.2156 14.6659 11.1352C14.6592 11.0549 14.5922 10.9879 14.5052 10.9946L14.2307 11.0147L14.2641 11.4901ZM14.3378 11.2223L14.5186 11.2089C14.552 11.2089 14.5788 11.1754 14.5721 11.1419C14.5721 11.1085 14.5387 11.0817 14.5052 11.0884L14.3244 11.1018L14.3378 11.2223Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6659 11.4633C14.6592 11.3964 14.6525 11.2424 14.5521 11.2558L14.4248 11.2625C14.5721 11.2491 14.5855 11.4031 14.5855 11.47",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8667 11.4566L15.0944 11.4499C15.2082 11.4499 15.2953 11.3562 15.2953 11.2424V11.1754C15.2953 11.0616 15.2015 10.9745 15.0877 10.9745L14.86 10.9812L14.8667 11.4566ZM14.9538 11.3629H15.081C15.1547 11.3629 15.2082 11.3026 15.2082 11.229V11.1888C15.2082 11.1152 15.148 11.0616 15.0743 11.0616H14.9471L14.9538 11.3629Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4761 11.4499L15.9046 11.4633V11.3763L15.5564 11.3629L15.5631 11.2424L15.8376 11.2491V11.1687L15.5631 11.162L15.5698 11.0616L15.8979 11.075V10.9879L15.4895 10.9745L15.4761 11.4499Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0787 11.4767L16.159 11.4834L16.1858 11.1553L16.2528 11.4901L16.3264 11.4968L16.4536 11.1821L16.4202 11.5035L16.5072 11.5102L16.5474 11.0348L16.4268 11.0281L16.3063 11.3428L16.2394 11.008L16.1188 11.0013L16.0787 11.4767Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0629 11.5839L17.4178 11.6441L17.4312 11.5638L17.1567 11.5169L17.1768 11.4098L17.3977 11.45L17.4111 11.3696L17.1901 11.3294L17.2035 11.2558L17.4647 11.3027L17.4781 11.2223L17.1366 11.162L17.0629 11.5839Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9669 11.7646L18.0539 11.7847L18.1008 11.6173L18.2883 11.6642C18.3686 11.6843 18.4489 11.6374 18.469 11.5571C18.4891 11.4767 18.4423 11.3964 18.3619 11.3763L18.1008 11.3093L17.9669 11.7646ZM18.1209 11.5303L18.3016 11.5772C18.3351 11.5838 18.3686 11.5638 18.3753 11.5303C18.382 11.4968 18.3619 11.4633 18.3284 11.4566L18.1476 11.4098L18.1209 11.5303Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5494 11.9186L18.6364 11.9454L18.69 11.778L18.8708 11.8383C18.9511 11.8651 19.0315 11.8182 19.0582 11.7379C19.085 11.6575 19.0382 11.5772 18.9578 11.5504L18.6967 11.47L18.5494 11.9186ZM18.7168 11.691L18.8909 11.7446C18.9243 11.7579 18.9578 11.7379 18.9712 11.7044C18.9846 11.6709 18.9645 11.6374 18.931 11.624L18.7569 11.5705L18.7168 11.691Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9377 12.0392C18.9578 11.9722 19.0047 11.8316 18.9042 11.7981L18.7837 11.758C18.9243 11.8048 18.8842 11.9454 18.8574 12.0124",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3261 12.1798C19.4399 12.2199 19.5671 12.153 19.6073 12.0325C19.6542 11.9119 19.6006 11.778 19.4868 11.7312C19.373 11.691 19.2457 11.7579 19.2056 11.8785C19.1654 12.0057 19.219 12.1396 19.3261 12.1798ZM19.3596 12.0994C19.4265 12.1262 19.5002 12.0793 19.527 12.0057C19.5537 11.9253 19.527 11.845 19.46 11.8182C19.393 11.7914 19.3194 11.8383 19.2926 11.9119C19.2658 11.9923 19.2926 12.0726 19.3596 12.0994Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8885 12.4074C19.9956 12.4543 20.1295 12.394 20.1831 12.2735C20.2367 12.153 20.1898 12.0191 20.0827 11.9722C19.9755 11.9253 19.8416 11.9856 19.7881 12.1061C19.7345 12.2199 19.7814 12.3606 19.8885 12.4074ZM19.922 12.3271C19.9822 12.3539 20.0626 12.3137 20.0961 12.24C20.1295 12.1664 20.1028 12.0793 20.0425 12.0526C19.9822 12.0258 19.9019 12.0659 19.8684 12.1396C19.8349 12.2133 19.8617 12.3003 19.922 12.3271Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0157 12.1999L20.1831 12.2735L20.1496 12.3338L19.989 12.2601L20.0157 12.1999Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1162 12.2467L20.1831 12.2735L20.0827 12.4945L20.0224 12.4677L20.1162 12.2467Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2434 12.5681L20.3237 12.6083L20.4041 12.4476L20.5715 12.5347C20.6451 12.5748 20.7389 12.5413 20.7723 12.4677C20.8058 12.394 20.779 12.307 20.7054 12.2668L20.4643 12.1463L20.2434 12.5681ZM20.4442 12.3673L20.6116 12.4476C20.6451 12.461 20.6786 12.4476 20.692 12.4208C20.7054 12.3873 20.692 12.3539 20.6652 12.3405L20.4978 12.2601L20.4442 12.3673Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.605 12.7489C20.6384 12.6886 20.6987 12.5547 20.6117 12.5079L20.4978 12.4476C20.6317 12.5146 20.5648 12.6485 20.5313 12.7087",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7857 12.8427L21.154 13.0502L21.2009 12.9766L20.8996 12.8025L20.9598 12.6953L21.1942 12.8293L21.2343 12.7623L21 12.6284L21.0469 12.5413L21.3281 12.702L21.375 12.6284L21.0201 12.4275L20.7857 12.8427Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4754 13.0703C21.4486 13.1105 21.4754 13.1574 21.5357 13.1908C21.5959 13.2243 21.6294 13.2243 21.6495 13.1975C21.703 13.1172 21.4017 12.9967 21.4955 12.856C21.5758 12.7355 21.7097 12.8293 21.7633 12.8627C21.8169 12.8962 21.8972 12.9833 21.8303 13.077L21.7432 13.0234C21.77 12.9833 21.7432 12.9364 21.6964 12.9096C21.6562 12.8828 21.616 12.8694 21.5892 12.9096C21.5424 12.9766 21.837 13.1038 21.7499 13.2444C21.683 13.3515 21.5691 13.3047 21.4888 13.2511C21.4218 13.2109 21.3214 13.1105 21.3884 13.01L21.4754 13.0703Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.991 13.4118C21.9642 13.4519 21.9843 13.4988 22.0445 13.539C22.0981 13.5792 22.1383 13.5792 22.1584 13.5524C22.2119 13.472 21.9173 13.3381 22.0178 13.2042C22.1048 13.0837 22.2387 13.1908 22.2856 13.2243C22.3325 13.2578 22.4128 13.3515 22.3458 13.4452L22.2588 13.385C22.2856 13.3448 22.2588 13.2979 22.2186 13.2712C22.1785 13.2377 22.1383 13.2243 22.1115 13.2645C22.0646 13.3247 22.3525 13.472 22.2521 13.6059C22.1785 13.7064 22.0646 13.6528 21.991 13.6059C21.9307 13.5591 21.837 13.4586 21.9039 13.3582L21.991 13.4118Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4731 13.9608C22.5668 14.0345 22.7074 14.0077 22.7877 13.9073C22.8681 13.8068 22.8614 13.6595 22.7677 13.5859C22.6739 13.5122 22.5333 13.5323 22.453 13.6394C22.3726 13.7399 22.3793 13.8872 22.4731 13.9608ZM22.5266 13.8872C22.5802 13.9273 22.6672 13.914 22.7208 13.847C22.7744 13.78 22.7677 13.693 22.7141 13.6528C22.6605 13.6127 22.5735 13.626 22.5199 13.693C22.4731 13.76 22.4731 13.847 22.5266 13.8872Z",
    fill: "#3D9244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0633 11.8852L13.9963 12.086L14.0967 12.1195L14.0633 11.8852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0633 11.8852L14.1235 12.086L14.0231 12.1195L14.0633 11.8852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2642 12.0325H14.0499V12.1396L14.2642 12.0325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2641 12.0325L14.09 12.1597L14.0298 12.0726L14.2641 12.0325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8557 12.0325L14.0298 12.1597L14.0901 12.0726L13.8557 12.0325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8557 12.0325H14.07V12.1396L13.8557 12.0325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1838 12.2735L14.1169 12.0659L14.0164 12.0994L14.1838 12.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1838 12.2735L14.0097 12.1463L14.0767 12.0593L14.1838 12.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9361 12.2735L14.1102 12.1463L14.0432 12.0593L13.9361 12.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9361 12.2735L14.003 12.0659L14.1035 12.0994L13.9361 12.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5052 13.9876L14.4382 14.1885L14.5387 14.222L14.5052 13.9876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5052 13.9876L14.5655 14.1885L14.465 14.222L14.5052 13.9876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 14.1349H14.4918V14.242L14.7061 14.1349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 14.1349L14.532 14.2621L14.4717 14.1751L14.7061 14.1349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2976 14.1349L14.4717 14.2621L14.532 14.1751L14.2976 14.1349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2976 14.1349H14.5119V14.242L14.2976 14.1349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6257 14.376L14.5587 14.1684L14.4583 14.2019L14.6257 14.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6257 14.376L14.4516 14.2488L14.5186 14.1617L14.6257 14.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.378 14.376L14.552 14.2488L14.4851 14.1617L14.378 14.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.378 14.376L14.4449 14.1684L14.5454 14.2019L14.378 14.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8892 14.5032L13.849 14.6438L13.916 14.6639L13.8892 14.5032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8892 14.5032L13.9361 14.6438L13.8691 14.6639L13.8892 14.5032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0231 14.6036H13.8825V14.6773L14.0231 14.6036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0231 14.6036L13.9093 14.6907L13.8691 14.6304L14.0231 14.6036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7553 14.6036L13.8691 14.6907L13.9093 14.6304L13.7553 14.6036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7553 14.6036H13.8959V14.6773L13.7553 14.6036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9762 14.7643L13.9294 14.6304L13.8624 14.6505L13.9762 14.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9762 14.7643L13.8557 14.6773L13.9026 14.6237L13.9762 14.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8088 14.7643L13.9227 14.6773L13.8825 14.6237L13.8088 14.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8088 14.7643L13.849 14.6304L13.916 14.6505L13.8088 14.7643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.994 13.7934L14.9605 13.8872L15.0074 13.9073L14.994 13.7934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.994 13.7934L15.0207 13.8872L14.9739 13.9073L14.994 13.7934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0877 13.8604H14.9873V13.9139L15.0877 13.8604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0877 13.8604L15.0074 13.9206L14.9739 13.8805L15.0877 13.8604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8935 13.8604L14.9739 13.9206L15.0074 13.8805L14.8935 13.8604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8935 13.8604H14.994V13.9139L14.8935 13.8604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0542 13.9742L15.0207 13.8805L14.9739 13.8939L15.0542 13.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0542 13.9742L14.9672 13.914L15.0007 13.8738L15.0542 13.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9337 13.9742L15.0141 13.914L14.9873 13.8738L14.9337 13.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9337 13.9742L14.9605 13.8805L15.0141 13.8939L14.9337 13.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.543 14.5166L15.4894 14.6907L15.5698 14.7174L15.543 14.5166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.543 14.5166L15.5966 14.6907L15.5162 14.7174L15.543 14.5166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7104 14.6438H15.5363V14.7308L15.7104 14.6438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7104 14.6438L15.5698 14.7442L15.5162 14.6773L15.7104 14.6438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3756 14.6438L15.5163 14.7442L15.5698 14.6773L15.3756 14.6438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3756 14.6438H15.5497V14.7308L15.3756 14.6438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6502 14.838L15.5899 14.6706L15.5096 14.6973L15.6502 14.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6501 14.838L15.5028 14.7375L15.5564 14.6639L15.6501 14.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4359 14.838L15.5832 14.7375L15.5296 14.6639L15.4359 14.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4359 14.838L15.4961 14.6706L15.5765 14.6973L15.4359 14.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3957 15.0121L15.3354 15.1861L15.4225 15.2129L15.3957 15.0121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3957 15.0121L15.4493 15.1861L15.3622 15.2129L15.3957 15.0121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5631 15.1393H15.3823V15.2263L15.5631 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5631 15.1393L15.4158 15.2464L15.3689 15.1728L15.5631 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2216 15.1393L15.3689 15.2464L15.4225 15.1728L15.2216 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2216 15.1393H15.4024V15.2263L15.2216 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4961 15.3401L15.4426 15.166L15.3555 15.1928L15.4961 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4961 15.3401L15.3555 15.233L15.4091 15.1594L15.4961 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2886 15.3401L15.4359 15.233L15.3823 15.1594L15.2886 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2886 15.3401L15.3421 15.166L15.4292 15.1928L15.2886 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6943 11.229L19.6274 11.4366L19.7278 11.47L19.6943 11.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6943 11.229L19.7613 11.4366L19.6542 11.47L19.6943 11.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8952 11.3763H19.6809V11.4834L19.8952 11.3763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8952 11.3763L19.7211 11.5035L19.6609 11.4165L19.8952 11.3763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4868 11.3763L19.6609 11.5035L19.7278 11.4165L19.4868 11.3763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4868 11.3763H19.701V11.4834L19.4868 11.3763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8149 11.6173L19.7546 11.4165L19.6475 11.45L19.8149 11.6173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8149 11.6173L19.6475 11.4901L19.7077 11.4031L19.8149 11.6173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5671 11.6173L19.7412 11.4901L19.6743 11.4031L19.5671 11.6173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5671 11.6173L19.6341 11.4165L19.7345 11.45L19.5671 11.6173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6428 14.5367L21.5758 14.7442L21.683 14.771L21.6428 14.5367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6428 14.5367L21.7097 14.7442L21.6093 14.771L21.6428 14.5367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8503 14.684H21.6361V14.7911L21.8503 14.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8504 14.684L21.6763 14.8112L21.6093 14.7241L21.8504 14.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4419 14.684L21.616 14.8112L21.6763 14.7241L21.4419 14.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4419 14.684H21.6562V14.7911L21.4419 14.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.77 14.925L21.703 14.7242L21.6026 14.7509L21.77 14.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.77 14.925L21.5959 14.7978L21.6629 14.7108L21.77 14.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5156 14.925L21.6897 14.7978L21.6294 14.7108L21.5156 14.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5156 14.925L21.5825 14.7242L21.683 14.7509L21.5156 14.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3391 14.6572L22.2923 14.7911L22.3592 14.8112L22.3391 14.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3391 14.6572L22.3793 14.7911L22.3123 14.8112L22.3391 14.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.473 14.7576H22.3324V14.8246L22.473 14.7576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4731 14.7576L22.3592 14.838L22.3191 14.7844L22.4731 14.7576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1985 14.7576L22.319 14.838L22.3592 14.7844L22.1985 14.7576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1985 14.7576H22.3458V14.8246L22.1985 14.7576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4195 14.9116L22.3793 14.7777L22.3123 14.7978L22.4195 14.9116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4195 14.9116L22.3057 14.8313L22.3458 14.771L22.4195 14.9116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2521 14.9116L22.3659 14.8313L22.3258 14.771L22.2521 14.9116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2521 14.9116L22.299 14.7777L22.3659 14.7978L22.2521 14.9116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8504 15.0121L21.7901 15.1861L21.8771 15.2129L21.8504 15.0121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8503 15.0121L21.9039 15.1861L21.8169 15.2129L21.8503 15.0121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0178 15.1393H21.837V15.2263L22.0178 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0178 15.1393L21.8704 15.2464L21.8236 15.1728L22.0178 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6763 15.1393L21.8236 15.2464L21.8771 15.1728L21.6763 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6763 15.1393H21.8571V15.2263L21.6763 15.1393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9508 15.3401L21.8972 15.166L21.8102 15.1928L21.9508 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9508 15.3401L21.8102 15.233L21.8637 15.1594L21.9508 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7432 15.3401L21.8905 15.233L21.837 15.1594L21.7432 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7432 15.3401L21.7968 15.166L21.8838 15.1928L21.7432 15.3401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6451 16.0633L20.5916 16.2307L20.6719 16.2574L20.6451 16.0633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6451 16.0633L20.6987 16.2307L20.6117 16.2574L20.6451 16.0633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 16.1838H20.6384V16.2775L20.8125 16.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 16.1838L20.6719 16.2909L20.6183 16.2173L20.8125 16.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4777 16.1838L20.6183 16.2909L20.6719 16.2173L20.4777 16.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4777 16.1838H20.6518V16.2775L20.4777 16.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7523 16.3847L20.692 16.2173L20.6117 16.2441L20.7523 16.3847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7523 16.3847L20.6049 16.2775L20.6585 16.2106L20.7523 16.3847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.538 16.3847L20.6853 16.2775L20.6317 16.2106L20.538 16.3847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.538 16.3847L20.5916 16.2173L20.6786 16.2441L20.538 16.3847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6384 16.5989L20.5916 16.7395L20.6585 16.7596L20.6384 16.5989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6384 16.5989L20.6786 16.7395L20.6117 16.7596L20.6384 16.5989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7724 16.6994H20.6317V16.773L20.7724 16.6994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7723 16.6994L20.6585 16.7864L20.6183 16.7262L20.7723 16.6994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5045 16.6994L20.6183 16.7864L20.6585 16.7262L20.5045 16.6994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5045 16.6994H20.6451V16.773L20.5045 16.6994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7188 16.86L20.6786 16.7261L20.6117 16.7462L20.7188 16.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7188 16.8601L20.6049 16.773L20.6451 16.7195L20.7188 16.8601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5514 16.8601L20.6719 16.773L20.625 16.7195L20.5514 16.8601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5514 16.86L20.5983 16.7261L20.6652 16.7462L20.5514 16.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 15.7017L21.0938 15.8423L21.1674 15.8624L21.1406 15.7017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 15.7017L21.1875 15.8423L21.1138 15.8624L21.1406 15.7017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2745 15.8022H21.1339V15.8758L21.2745 15.8022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2745 15.8022L21.1607 15.8892L21.1205 15.8289L21.2745 15.8022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0067 15.8022L21.1205 15.8892L21.1607 15.8289L21.0067 15.8022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0067 15.8022H21.1473V15.8758L21.0067 15.8022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2277 15.9628L21.1808 15.8289L21.1138 15.849L21.2277 15.9628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2276 15.9628L21.1071 15.8758L21.154 15.8222L21.2276 15.9628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0603 15.9628L21.1741 15.8758L21.1272 15.8222L21.0603 15.9628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0603 15.9628L21.1004 15.8289L21.1674 15.849L21.0603 15.9628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5423 15.4138L21.4888 15.5879L21.5691 15.6147L21.5423 15.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5423 15.4138L21.5959 15.5879L21.5156 15.6147L21.5423 15.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7097 15.541H21.5356V15.6281L21.7097 15.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7097 15.541L21.5691 15.6415L21.5156 15.5745L21.7097 15.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 15.541L21.5156 15.6415L21.5691 15.5745L21.375 15.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 15.541H21.5491V15.6281L21.375 15.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6495 15.7352L21.5892 15.5678L21.5089 15.5946L21.6495 15.7352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6495 15.7352L21.5022 15.6347L21.5557 15.5611L21.6495 15.7352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4352 15.7352L21.5825 15.6347L21.529 15.5611L21.4352 15.7352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4352 15.7352L21.4955 15.5678L21.5758 15.5946L21.4352 15.7352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6251 15.608L20.5782 15.7419L20.6451 15.7687L20.6251 15.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 15.608L20.6652 15.7419L20.5983 15.7687L20.625 15.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.759 15.7084H20.6183V15.7754L20.759 15.7084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.759 15.7084L20.6451 15.7888L20.6049 15.7352L20.759 15.7084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4911 15.7084L20.6049 15.7888L20.6451 15.7352L20.4911 15.7084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4911 15.7084H20.6317V15.7754L20.4911 15.7084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7054 15.8691L20.6652 15.7285L20.5983 15.7486L20.7054 15.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7054 15.8691L20.5916 15.7821L20.6317 15.7285L20.7054 15.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.538 15.8691L20.6585 15.7821L20.6116 15.7285L20.538 15.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.538 15.8691L20.5849 15.7285L20.6518 15.7486L20.538 15.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2394 13.0234L16.1791 13.1908L16.2662 13.2176L16.2394 13.0234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2394 13.0234L16.2929 13.1908L16.2059 13.2176L16.2394 13.0234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4068 13.144H16.226V13.231L16.4068 13.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4068 13.144L16.2595 13.2511L16.2126 13.1774L16.4068 13.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0653 13.144L16.2126 13.2511L16.2661 13.1774L16.0653 13.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0653 13.144H16.2461V13.231L16.0653 13.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 13.3448L16.2862 13.1774L16.1992 13.2042L16.3398 13.3448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 13.3448L16.1992 13.2377L16.2528 13.164L16.3398 13.3448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1322 13.3448L16.2728 13.2377L16.226 13.164L16.1322 13.3448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1322 13.3448L16.1858 13.1774L16.2728 13.2042L16.1322 13.3448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 12.6016L19.46 12.7355L19.5269 12.7623L19.5002 12.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 12.6016L19.547 12.7355L19.4801 12.7623L19.5002 12.6016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6341 12.7021H19.4935V12.769L19.6341 12.7021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6341 12.7021L19.5202 12.7824L19.4801 12.7288L19.6341 12.7021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3662 12.7021L19.4801 12.7824L19.5202 12.7288L19.3662 12.7021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3662 12.7021H19.5069V12.769L19.3662 12.7021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5872 12.8627L19.5403 12.7221L19.4734 12.7489L19.5872 12.8627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5872 12.8627L19.4667 12.7757L19.5135 12.7154L19.5872 12.8627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4198 12.8627L19.5337 12.7757L19.4935 12.7154L19.4198 12.8627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4198 12.8627L19.46 12.7221L19.527 12.7489L19.4198 12.8627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 15.0255L18.074 15.233L18.1744 15.2665L18.1409 15.0255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 15.0255L18.2079 15.233L18.1075 15.2665L18.1409 15.0255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3418 15.1728H18.1276V15.2799L18.3418 15.1728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3418 15.1728L18.1744 15.3L18.1075 15.2129L18.3418 15.1728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9401 15.1728L18.1075 15.3L18.1744 15.2129L17.9401 15.1728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9401 15.1728H18.1543V15.2799L17.9401 15.1728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2682 15.4138L18.2012 15.2129L18.1008 15.2464L18.2682 15.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2682 15.4138L18.0941 15.2866L18.1543 15.1995L18.2682 15.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0137 15.4138L18.1878 15.2866L18.1276 15.1995L18.0137 15.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0137 15.4138L18.0807 15.2129L18.1811 15.2464L18.0137 15.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7168 14.068L18.6632 14.2354L18.7503 14.2688L18.7168 14.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7168 14.068L18.777 14.2354L18.69 14.2688L18.7168 14.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8909 14.1952H18.7101V14.2822L18.8909 14.1952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8909 14.1952L18.7436 14.2956L18.69 14.222L18.8909 14.1952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5494 14.1952L18.6967 14.2956L18.7436 14.222L18.5494 14.1952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5494 14.1952H18.7302V14.2822L18.5494 14.1952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8239 14.3893L18.7703 14.222L18.6833 14.2487L18.8239 14.3893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8239 14.3894L18.6766 14.2889L18.7302 14.2153L18.8239 14.3894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6163 14.3894L18.7569 14.2889L18.7034 14.2153L18.6163 14.3894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6163 14.3893L18.6699 14.222L18.7569 14.2487L18.6163 14.3893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 13.6194L18.0874 13.7934L18.1677 13.8202L18.1409 13.6194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 13.6194L18.1945 13.7934L18.1142 13.8202L18.1409 13.6194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3083 13.7466H18.1342V13.8336L18.3083 13.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3083 13.7466L18.1677 13.847L18.1142 13.7734L18.3083 13.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9735 13.7466L18.1142 13.847L18.1677 13.7734L17.9735 13.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9735 13.7466H18.1476V13.8336L17.9735 13.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2481 13.9407L18.1878 13.7733L18.1075 13.8001L18.2481 13.9407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2481 13.9408L18.1008 13.8403L18.1543 13.7667L18.2481 13.9408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0338 13.9408L18.1811 13.8403L18.1276 13.7667L18.0338 13.9408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0338 13.9407L18.0941 13.7733L18.1744 13.8001L18.0338 13.9407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6388 14.1081L17.5919 14.242L17.6588 14.2621L17.6388 14.1081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6388 14.1081L17.6789 14.242L17.612 14.2621L17.6388 14.1081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7727 14.2019H17.6321V14.2755L17.7727 14.2019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7727 14.2019L17.6589 14.2889L17.6187 14.2287L17.7727 14.2019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5049 14.2019L17.6187 14.2889L17.6589 14.2287L17.5049 14.2019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5049 14.2019H17.6455V14.2755L17.5049 14.2019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7191 14.3626L17.6789 14.2287L17.612 14.2488L17.7191 14.3626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7191 14.3626L17.6053 14.2822L17.6455 14.222L17.7191 14.3626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5517 14.3626L17.6722 14.2822L17.6254 14.222L17.5517 14.3626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5517 14.3626L17.5986 14.2287L17.6656 14.2488L17.5517 14.3626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8865 14.4898L17.8597 14.5902L17.9066 14.6036L17.8865 14.4898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8865 14.4898L17.92 14.5902L17.8731 14.6036L17.8865 14.4898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9869 14.5634H17.8865V14.617L17.9869 14.5634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9869 14.5634L17.9066 14.6237L17.8731 14.5835L17.9869 14.5634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7928 14.5634L17.8731 14.6237L17.9066 14.5835L17.7928 14.5634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7928 14.5634H17.8932V14.617L17.7928 14.5634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9468 14.6773L17.92 14.5768L17.8664 14.5969L17.9468 14.6773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9468 14.6773L17.8664 14.617L17.8999 14.5768L17.9468 14.6773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8262 14.6773L17.9133 14.617L17.8798 14.5768L17.8262 14.6773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8262 14.6773L17.8597 14.5768L17.9066 14.5969L17.8262 14.6773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6408 16.1838L19.5805 16.3579L19.6675 16.3847L19.6408 16.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6408 16.1838L19.6943 16.3579L19.6073 16.3847L19.6408 16.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8082 16.3043H19.6274V16.3981L19.8082 16.3043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8082 16.3043L19.6609 16.4115L19.6073 16.3378L19.8082 16.3043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4667 16.3043L19.614 16.4115L19.6675 16.3378L19.4667 16.3043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4667 16.3043H19.6475V16.3981L19.4667 16.3043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7412 16.5052L19.6876 16.3378L19.6006 16.3646L19.7412 16.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7412 16.5052L19.6006 16.4048L19.6475 16.3311L19.7412 16.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5336 16.5052L19.6742 16.4048L19.6274 16.3311L19.5336 16.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5336 16.5052L19.5872 16.3378L19.6742 16.3646L19.5336 16.5052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0626 15.7754L20.0224 15.916L20.0894 15.9361L20.0626 15.7754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0626 15.7754L20.1095 15.916L20.0425 15.9361L20.0626 15.7754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2032 15.8758H20.0559V15.9494L20.2032 15.8758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2032 15.8758L20.0894 15.9628L20.0425 15.9026L20.2032 15.8758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9287 15.8758L20.0425 15.9628L20.0894 15.9026L19.9287 15.8758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9287 15.8758H20.076V15.9494L19.9287 15.8758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1497 16.0365L20.1028 15.9026L20.0358 15.9227L20.1497 16.0365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1497 16.0365L20.0358 15.9561L20.076 15.8959L20.1497 16.0365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9823 16.0365L20.0961 15.9561L20.0559 15.8959L19.9823 16.0365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9823 16.0365L20.0291 15.9026L20.0961 15.9227L19.9823 16.0365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2457 15.6548L19.1989 15.7888L19.2658 15.8155L19.2457 15.6548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2457 15.6548L19.2859 15.7888L19.2189 15.8155L19.2457 15.6548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3797 15.7553H19.239V15.8289L19.3797 15.7553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3796 15.7553L19.2658 15.8356L19.2189 15.7821L19.3796 15.7553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1051 15.7553L19.2257 15.8356L19.2658 15.7821L19.1051 15.7553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1051 15.7553H19.2524V15.8289L19.1051 15.7553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3261 15.916L19.2859 15.7754L19.2122 15.8021L19.3261 15.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3261 15.916L19.2122 15.8289L19.2524 15.7754L19.3261 15.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1587 15.916L19.2725 15.8289L19.2323 15.7754L19.1587 15.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1587 15.916L19.2056 15.7754L19.2725 15.8021L19.1587 15.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1323 15.4339L16.072 15.6347L16.1724 15.6749L16.1323 15.4339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1322 15.4339L16.1992 15.6347L16.0988 15.6749L16.1322 15.4339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 15.5812H16.1255V15.6883L16.3398 15.5812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 15.5812L16.1657 15.7084L16.1055 15.6214L16.3398 15.5812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9314 15.5812L16.1055 15.7084L16.1657 15.6214L15.9314 15.5812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9314 15.5812H16.1456V15.6883L15.9314 15.5812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2595 15.8222L16.1925 15.6214L16.0921 15.6548L16.2595 15.8222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2594 15.8222L16.0854 15.695L16.1523 15.608L16.2594 15.8222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.005 15.8222L16.1791 15.695L16.1188 15.608L16.005 15.8222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.005 15.8222L16.072 15.6214L16.1791 15.6548L16.005 15.8222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 16.8333L18.1208 16.9069L18.1543 16.9136L18.1409 16.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.141 16.8333L18.161 16.9069L18.1276 16.9136L18.141 16.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2079 16.8868H18.1342V16.9203L18.2079 16.8868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2079 16.8868L18.1543 16.927L18.1276 16.9002L18.2079 16.8868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.074 16.8868L18.1342 16.927L18.1543 16.9002L18.074 16.8868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.074 16.8868H18.1476V16.9203L18.074 16.8868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1811 16.9672L18.161 16.9002L18.1276 16.9069L18.1811 16.9672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1811 16.9672L18.1276 16.9203L18.1477 16.8936L18.1811 16.9672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1008 16.9672L18.1543 16.9203L18.1342 16.8936L18.1008 16.9672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1008 16.9672L18.1209 16.9002L18.1543 16.9069L18.1008 16.9672Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_4819",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_4819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_4819",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/Brazil.37cf7bdf70c4a40942c09e090e1a0b8a.svg";
export { ForwardRef as ReactComponent };